import { createAction } from "redux-actions";
import { CommonConstants } from "./commonConstants";

export const fetchStates = createAction(CommonConstants.FETCH_STATES);
export const fetchProducts = createAction(CommonConstants.FETCH_PRODUCTS);
export const fetchTimeZones = createAction(CommonConstants.FETCH_TIMEZONES);
